<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite tip uporabnika {{ userType.name }}:
    </h2>

    <UserTypeForm
      @save="save"
      @cancel="cancel"
      :userType="userType"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { loadItem, saveItem } from '@/utils/crudFunctions'
import UserTypeForm from '@/components/UserTypeForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    UserTypeForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  computed: {
    userType () {
      return this.$store.state.userTypes.items[this.id]
    },
  },
  methods: {
    ...mapActions('userTypes', ['loadItem', 'saveItem']),
    save ({ data }) {
      saveItem(data, 'MyCompanyUserTypes', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyUserTypes' })
    }
  },
  created () {
    loadItem(this)
  }
}
</script>
